export default __webpack_public_path__ + "static/media/calendar.8875528e.svg";